import { TerminalStatus, TerminalStatusContext } from '../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../components/execution/terminal/AllStatusWrapper'
import { postCTA } from '../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../utils/mutualFundDetail'

export const SIPOrderSuccessPage = () => {
  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={TerminalStatus.FULL_SUCCESS}
        statusContext={TerminalStatusContext.SIP}
        fullSuccessConfig={{
          title: 'Your SIP is all set',
          caption: 'Your first SIP will be auto-debited in 1-2 working <br /> days.',
          ctas: [
            {
              ctaType: 'secondary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
